import { IconComponent, themeColor } from 'LibNeo'
import styled from 'styled-components'
import { IconStyled } from 'LibNeo/components/Basic/Icon/Icon/styled'

export const IconAbsolute = styled(IconComponent)`
	position: absolute;
	z-index: 2;
	top: 0;
	right: 0;
	width: 14px;
	height: 14px;
	background-color: ${themeColor('colorMainBg')};
	border-radius: 50%;
	${IconStyled} {
		width: 14px;
		height: 14px;
	}
`
